__turbopack_context__.v({
  "galleryBtn": "YAFcFW_galleryBtn",
  "media": "YAFcFW_media",
  "mediaArea": "YAFcFW_mediaArea",
  "nav": "YAFcFW_nav",
  "navNext": "YAFcFW_navNext",
  "navPrev": "YAFcFW_navPrev",
  "root": "YAFcFW_root",
  "slide": "YAFcFW_slide",
  "slideVertical": "YAFcFW_slideVertical",
  "slideWide": "YAFcFW_slideWide",
  "track": "YAFcFW_track",
  "trackBar": "YAFcFW_trackBar",
  "trackSegment": "YAFcFW_trackSegment",
  "trackSegmentActive": "YAFcFW_trackSegmentActive",
});
